import { httpClient } from "lib/axios";

export const delivery_time_api = {
  get_list: async () => {
    return await httpClient
      .get("/delivery-time/")
      .then((res) => res.data)
      .catch((err) => err);
  },

  create_variant: async (payload) => {
    return await httpClient
      .post("/delivery-time/", payload)
      .then((res) => res.data)
      .catch((err) => err);
  },

  delete_variant: async (id) => {
    return await httpClient
      .delete(`/delivery-time/?id=${id}`)
      .then((res) => res.data)
      .catch((err) => err);
  },
};
